import { isMuttavatteenOutstandingBroadcastEnabledForTenant } from "@/utils/muttavatteen-outstanding-broadcast";
import { useTenantFeatureGate } from "./use-tenant-feature-gate";

/**
 * Whether Mutawatteen Outstanding broadcast mode is available for the effective tenant
 * (JWT `tenantId`, or `localStorage.impersonatedTenantId` for super-admin).
 */
export function useIsMuttavatteenOutstandingBroadcastEnabled(): boolean {
  return useTenantFeatureGate(isMuttavatteenOutstandingBroadcastEnabledForTenant);
}
